// Krysha content config

export const IMAGES = {
  heroSlider: [
    'https://static.prod-images.emergentagent.com/jobs/3a336af4-9190-4ca4-95ac-a0cccc6d94bc/images/6d6324cabf2b9c0f0b45e8ed29d4cadde5d8e41cf174702ffe5ff6b936e2dcf8.jpeg',
    'https://static.prod-images.emergentagent.com/jobs/3a336af4-9190-4ca4-95ac-a0cccc6d94bc/images/14b55f3ea3743945a63567a6a01f5a1616fccbe3759584184096472981125081.jpeg',
    'https://static.prod-images.emergentagent.com/jobs/3a336af4-9190-4ca4-95ac-a0cccc6d94bc/images/efb0c01b4949e6a8ea0ca79af645edc45698bf895200ad7872143f80e8f07664.jpeg',
    'https://static.prod-images.emergentagent.com/jobs/3a336af4-9190-4ca4-95ac-a0cccc6d94bc/images/0e3684b96b67f1ce747281c53015159e1707f37124146075760752565a6b3207.jpeg',
  ],
  testimonials: [
    'https://static.prod-images.emergentagent.com/jobs/3a336af4-9190-4ca4-95ac-a0cccc6d94bc/images/af8beb0318feaf630d813ac7d5cd928a478c693640981b489b56319cd4071cf1.jpeg',
    'https://static.prod-images.emergentagent.com/jobs/3a336af4-9190-4ca4-95ac-a0cccc6d94bc/images/9d411e42fd16f67d783a9aa4f72bcb18bc27946b97645d38bf965de71ac955e8.jpeg',
    'https://static.prod-images.emergentagent.com/jobs/3a336af4-9190-4ca4-95ac-a0cccc6d94bc/images/6cb47b744ce32b4ec81d6dc381c5469f1a4478e47fb82111aad50011ecb50512.jpeg',
    'https://static.prod-images.emergentagent.com/jobs/3a336af4-9190-4ca4-95ac-a0cccc6d94bc/images/9a2ba035d306e596abd6c983427089711a7773b8326cd7176eb13c04e82d62e5.jpeg',
  ],
  gallery: [
    'https://images.pexels.com/photos/8528876/pexels-photo-8528876.jpeg?auto=compress&cs=tinysrgb&w=800',
    'https://images.pexels.com/photos/31558934/pexels-photo-31558934.jpeg?auto=compress&cs=tinysrgb&w=800',
    'https://images.unsplash.com/photo-1541089404510-5c9a779841fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    'https://images.unsplash.com/photo-1506014299253-3725319c0f69?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  ],
  guarantee: 'https://images.unsplash.com/photo-1574740688317-9684409a7434?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
};

export const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'How It Works', href: '#how' },
  { label: 'Why Krysha', href: '#why' },
  { label: 'Testimonials', href: '#stories' },
  { label: 'About Us', href: '#about' },
  { label: 'Contact Us', href: '#contact' },
];

export const HERO_FEATURES = [
  { icon: 'Heart', title: 'No Swiping', desc: 'No endless swiping' },
  { icon: 'ShieldCheck', title: '100% Privacy Assured', desc: 'Your privacy is our priority' },
  { icon: 'Target', title: 'Compatibility First', desc: 'We match your vibe' },
  { icon: 'Users', title: 'Personalized Matches', desc: 'Handpicked just for you' },
];

export const GUARANTEE_ITEMS = [
  { icon: 'ShieldCheck', title: '1 Month Match Guarantee', desc: 'No match in 1 month? Get your money back.*' },
  { icon: 'Lock', title: 'Trusted & Secure', desc: 'Your data is safe and confidential.' },
  { icon: 'Sparkles', title: 'Curated Matches', desc: 'We personally analyze and shortlist the best matches.' },
  { icon: 'Send', title: 'Connect Privately', desc: 'Get matches on WhatsApp, Email or Instagram.' },
];

export const ABOUT_CARDS = [
  { icon: 'ClipboardList', title: 'One form, not a hundred swipes', desc: 'Tell us about yourself once. No scrolling, no burnout — we take it from there.' },
  { icon: 'UserCheck', title: 'Matched by a person, not just an algorithm', desc: 'Every response is human-reviewed before any match is suggested.' },
  { icon: 'Send', title: 'Straight to you, no in-app maze', desc: 'Match details go straight to your inbox, WhatsApp or Instagram.' },
];

export const HOW_STEPS = [
  { num: 1, title: 'Tell us your vibe', desc: "Share who you are, what matters to you, and what you're looking for." },
  { num: 2, title: 'We understand you', desc: 'We review your preferences and look beyond just photos.' },
  { num: 3, title: 'We find the connection', desc: "When someone genuinely aligns with your vibe, we'll let you know." },
  { num: 4, title: 'You decide what happens next', desc: "If the connection feels right, we'll help you take the next step." },
];

export const COMPARE = {
  apps: {
    title: 'Swipe apps',
    items: [
      'Endless swiping, every single day',
      'Matched on a photo, nothing more',
      'Conversations stuck inside the app',
      'You do all the filtering yourself',
    ],
  },
  krysha: {
    title: 'Krysha',
    items: [
      'One form, reviewed by real people',
      'Matched on values, vibe & lifestyle',
      'Details sent directly to you',
      'We do the searching for you',
    ],
  },
};

export const FORM_STEPS = [
  'About You',
  'Lifestyle & Values',
  'Partner Preferences',
  'Review & Submit',
];

export const SECTION_TITLES = ['About You', 'Lifestyle & Values', 'Partner Preferences'];

// Config-driven schema for steps 1-3 (step 4 is contact + review)
// Relationship / dating types — shared by the matchmaking form and Match Preferences
export const RELATIONSHIP_OPTIONS = [
  'Marriage',
  'Serious Relationship',
  'Exclusive Relationship',
  'Long-term relationship',
  'Dating',
  'Casual Dating',
  'Situationship',
  'Talking Stage',
  'Taking It Slow',
  'Slow Dating',
  'Friends with Benefits',
  'Open to Exploring',
  'Not Sure Yet',
  'Still figuring it out',
];

export const FORM_SCHEMA = [
  // STEP 1 — ABOUT YOU
  {
    fields: [
      { type: 'text', name: 'name', label: 'Full Name', placeholder: 'Enter your full name', required: true },
      { type: 'select', name: 'gender', label: 'Gender', options: ['Woman', 'Man', 'Prefer not to say'], required: true },
      { type: 'number', name: 'age', label: 'Age', placeholder: 'Enter your age', required: true },
      { type: 'text', name: 'country', label: 'Country', placeholder: 'Enter your country', required: true },
      { type: 'text', name: 'city', label: 'City', placeholder: 'Enter your city', required: true },
      { type: 'text', name: 'occupation', label: 'Occupation', placeholder: 'Your occupation' },
      { type: 'select', name: 'education', label: 'Highest Education', options: ["High School", "Bachelor's", "Master's", 'Doctorate'] },
      { type: 'file', name: 'photo', label: 'Upload a photo (Optional)' },
      { type: 'radio', name: 'personality', label: 'What explains you the best?', full: true, options: ['Introvert', 'Extrovert', 'Ambivert'] },
      { type: 'checkbox', name: 'freeTime', label: 'What do you do in your free time?', full: true, options: ['Reading', 'Watching', 'Listening', 'Other'], allowOther: true },
      { type: 'textarea', name: 'funThing', label: "What's the most fun or interesting thing you've done?", placeholder: 'Tell us a memorable story about yourself', full: true },
      { type: 'textarea', name: 'about', label: 'Tell us about yourself', placeholder: 'Your values, lifestyle, what a normal weekend looks like for you...', full: true },
    ],
  },
  // STEP 2 — LIFESTYLE & VALUES
  {
    fields: [
      { type: 'radio', name: 'destiny', label: 'Do you believe in destiny?', full: true, options: ['Yes', 'No', 'Maybe'] },
      { type: 'radio', name: 'loveAtFirstSight', label: 'Do you believe in love at first sight?', full: true, options: ['Yes', 'No', 'Maybe'] },
      { type: 'text', name: 'color', label: 'Favourite colour(s)', placeholder: 'e.g. Black & white' },
      { type: 'text', name: 'pizza', label: "What's your favourite pizza topping?", placeholder: 'e.g. Cheese & corn' },
      { type: 'checkbox', name: 'idealDate', label: 'What would your ideal date be?', full: true, options: ['Candle Light Dinner', 'Meet With Flowers & Chocolate', 'Just Simple Tea/Coffee Date', 'Meet on Beach', 'Long Drive', 'Just Meet Up', 'Other'], allowOther: true },
      { type: 'checkbox', name: 'movieType', label: 'Which type of movies do you like?', full: true, options: ['Horror', 'Romantic', 'Comedy', 'Action', 'Thriller', 'Web-Series', 'Sad Story', 'Other'], allowOther: true },
      { type: 'radio', name: 'chronotype', label: 'Are you a morning person or a night owl?', full: true, options: ['Morning person', 'Night owl'] },
      { type: 'radio', name: 'wouldWork', label: 'If given a chance to not work and still have a permanent income, would you still work?', full: true, options: ['Yes', 'No'] },
      { type: 'checkbox', name: 'whenHappy', label: "What do you do when you're happy?", full: true, options: ['Enjoying Music', 'Go Out to Eat', 'Long Walk', 'Enjoying with Family', 'Sleeping', 'Party With Friends', 'Spend a Day with Lovable Person', 'Other'], allowOther: true },
      { type: 'checkbox', name: 'whenSad', label: "What do you do when you're sad?", full: true, options: ['Keep Myself Alone', 'Sleep', 'Talking with Friends', 'Spending Time with Family', 'Just Go Out Anywhere', 'Alone Long Walk', 'Scrolling Online', 'Other'], allowOther: true },
      { type: 'radio', name: 'shareFeelings', label: 'How often do you share your feelings?', full: true, options: ['Never Shared', 'Occasionally', 'Sometimes', 'Often', 'Always'] },
      { type: 'checkbox', name: 'cuisine', label: 'Select all the cuisines you enjoy', full: true, options: ['Italian', 'Continental', 'Tandoor', 'Asian', 'Chinese', 'Indian', 'Street Food', 'Other'], allowOther: true },
      { type: 'radio', name: 'foodTaste', label: 'How do you like your food?', full: true, options: ['Spicy', 'Sweet', 'Sweet & Salty', 'Everything'] },
    ],
  },
  // STEP 3 — PARTNER PREFERENCES
  {
    fields: [
      { type: 'select', name: 'looking', label: 'Looking For (Relationship Type)', full: true, options: RELATIONSHIP_OPTIONS, required: true },
      { type: 'radio', name: 'agePref', label: 'Age Preference', full: true, options: ['18-24', '24-30', '31-36', '37-44', 'Above 45', 'Age is just a number for me'], default: 'Age is just a number for me' },
      { type: 'checkbox', name: 'connectPlatform', label: 'Where do you want to connect with your best matching partner?', full: true, options: ['WhatsApp', 'Instagram', 'Facebook', 'Snapchat', 'Other'], default: ['WhatsApp'], allowOther: true, required: true },
      { type: 'text', name: 'socialId', label: 'Share your ID / preferred contact (Optional)', placeholder: 'e.g. +91 98765 43210 or @yourhandle', full: true },
      { type: 'radio', name: 'lookVsNature', label: "Is a person's look more important than their nature?", full: true, options: ['Yes', 'No', 'Maybe'], required: true },
      { type: 'radio', name: 'priority', label: 'What is more important for you?', full: true, options: ['Personal', 'Professional', 'Social', 'Balance of all'], default: 'Balance of all' },
      { type: 'textarea', name: 'partnerLike', label: 'What are you looking for in a partner?', placeholder: 'What matters most to you, and where you see this going...', full: true },
      { type: 'textarea', name: 'dealbreakers', label: 'Any dealbreakers?', placeholder: 'Things that are a hard no for you', full: true },
    ],
  },
];

// Contact / account details collected at Review & Submit (kept separate from profile questions)
export const CONTACT_FIELDS = [
  { type: 'email', name: 'email', label: 'Email Address', placeholder: 'Enter your email', required: true },
  { type: 'tel', name: 'phone', label: 'Contact / WhatsApp Number', placeholder: '+91 Enter your number', required: true,
    hint: 'Just for confirmation — or so we can call you for the refund process if no match is found.' },
  { type: 'checkbox', name: 'channel', label: 'How would you like us to contact you?', full: true, options: ['WhatsApp', 'Email', 'Instagram'], default: ['WhatsApp'] },
];

// Fields shown in the review summary (step 5)
export const REVIEW_FIELDS = [
  { name: 'name', label: 'Name' },
  { name: 'age', label: 'Age' },
  { name: 'city', label: 'City' },
  { name: 'email', label: 'Email' },
  { name: 'looking', label: 'Looking For' },
  { name: 'personality', label: 'Personality' },
  { name: 'agePref', label: 'Age Preference' },
  { name: 'channel', label: 'Contact Via' },
];

export const PLANS = [
  { id: '99', name: 'Single Signal', price: '\u20B999', per: '', icon: 'Heart', desc: '1 curated match', popular: false },
  { id: '199', name: 'Triple Tune', price: '\u20B9199', per: '', icon: 'HeartHandshake', desc: '3 curated matches', popular: true },
  { id: '999', name: 'All Access', price: '\u20B9999', per: '/ 1 Year', icon: 'Infinity', desc: 'Unlimited matches for 1 year', popular: false },
];

export const STATS = [
  { icon: 'Users', value: 'Growing', label: 'Community of genuine members' },
  { icon: 'Heart', value: 'Compatibility', label: 'Focused matching, not photos' },
  { icon: 'Star', value: 'Meaningful', label: 'Connections, not endless swipes' },
  { icon: 'ShieldCheck', value: 'Privacy', label: 'First — always protected' },
];

export const GALLERY = [
  { title: 'Find your kind of person.', desc: 'No endless swiping. Just your vibe.' },
  { title: 'Meaningful connections.', desc: 'We focus on compatibility that truly matters.' },
  { title: 'Built on trust & privacy.', desc: 'Your data is safe and never misused.' },
  { title: 'Meaningful possibilities.', desc: 'Thoughtful matchmaking, privately.' },
];

export const FAQS = [
  { q: 'What is Krysha Love Station?', a: 'Krysha Love Station is a personalized matchmaking platform. Instead of endless swiping, you fill one detailed form about your personality, lifestyle and preferences, and our team hand-picks compatible matches and shares their details with you privately on WhatsApp, Email or Instagram.' },
  { q: 'How does Krysha matchmaking work?', a: "You fill the matchmaking form once, choose a plan, and our team compares your answers — values, lifestyle, personality and preferences — against every other member. When someone genuinely aligns with your vibe, we'll let you know and help you connect on your preferred channel." },
  { q: 'Is Krysha a dating app?', a: 'Krysha is a matchmaking website, not a swipe-based dating app. There is no feed of profiles, no swiping and no in-app chat. You tell us what you are looking for once, and we do the searching and compatibility work for you.' },
  { q: 'How is Krysha different from swipe-based dating apps?', a: 'Swipe apps match people on a photo and leave all the filtering to you. Krysha matches on compatibility — one human-reviewed form covering values, vibe and lifestyle — and sends match details straight to you, so there is no daily swiping or app fatigue.' },
  { q: 'Does Krysha use swiping?', a: 'No. Krysha has no swiping at all. Our promise is simple: No Swiping. No Stress. Just Your Vibe. You complete one form and we take care of finding compatible matches for you.' },
  { q: 'How does Krysha find compatible matches?', a: 'Every answer in your form — personality, ideal dates, lifestyle habits, values and partner preferences — is compared against other members by a real person. We only suggest a match when the compatibility genuinely fits both sides.' },
  { q: 'Can I find a compatible partner through Krysha?', a: 'Yes — that is exactly what Krysha is built for. And we back it with a 1 Month Match Guarantee: if we cannot find you a suitable match within one month, you are eligible for a refund (a 10% processing charge applies).' },
  { q: 'Is Krysha available in India?', a: 'Yes. Krysha is an India-first matchmaking service with plans priced in rupees, and matches are shared over WhatsApp, Email or Instagram — so it works wherever you are.' },
];

export const TESTIMONIALS = [
  { names: 'Aditi & Rohan', match: '92% Match', city: 'Mumbai', tags: ['Night owls', 'Long walks', 'Similar goals'], text: "Both said 'night owl' and 'long walks' — matched on lifestyle, humour and where they want life to go." },
  { names: 'Sonam & Mukesh', match: '90% Match', city: 'Delhi', tags: ['Family first', 'Chai dates', 'Shared values'], text: 'Matched on family values, simple tea-date energy and the same idea of a meaningful relationship.' },
  { names: 'Priyanka & Varun', match: '95% Match', city: 'Pune', tags: ['Travel lovers', 'Foodies', 'Same humour'], text: 'Matched on love for travel, street food and a balance-of-all outlook on life and work.' },
  { names: 'Ishaan & Neha', match: '89% Match', city: 'Bengaluru', tags: ['Bookworms', 'Morning people', 'Similar lifestyle'], text: 'Matched on quiet-weekend lifestyles, reading habits and compatible relationship expectations.' },
];

// ===== Logged-in profile & matching preference options =====
export const PROFILE_OPTIONS = {
  gender: ['Woman', 'Man', 'Prefer not to say'],
  education: ["High School", "Bachelor's", "Master's", 'Doctorate'],
  personality: ['Introvert', 'Extrovert', 'Ambivert'],
  looking: RELATIONSHIP_OPTIONS,
  interests: ['Reading', 'Music', 'Movies', 'Travel', 'Foodie', 'Cooking', 'Fitness', 'Photography', 'Gaming', 'Art', 'Nature', 'Pets', 'Dancing', 'Sports', 'Writing', 'Tech'],
  lifestyle: ['Morning person', 'Night owl', 'Spicy', 'Sweet', 'Sweet & Salty', 'Everything', 'Fitness focused', 'Homebody', 'Social butterfly', 'Traveller', 'Vegetarian', 'Spiritual'],
};
